import { Widget } from 'jamespot-front-business';
import React, { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import styled, { useTheme } from 'styled-components';
import { useAppSelector } from '../../../../redux/store';
import { WidgetIntranetTitle } from './WidgetIntranetTitle';

export const UIHeaderWrapper = styled.div<{ backroundColor: string }>`
    background-color: ${(props) => props.backroundColor};
`;

export const UIHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const UICount = styled.div`
    padding: ${(props) => props.theme.space.sm}px ${(props) => props.theme.space.md}px;
    color: ${(props) => props.theme.color.grey4};
`;

export const UIHeaderFlex = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: ${(props) => props.theme.space.xs}px;
    align-items: center;
`;

export const WidgetHeader = ({
    uniqid,
    dropdown,
    subHeader,
}: {
    uniqid: string;
    dropdown?: () => React.ReactNode;
    subHeader?: (color: string) => React.ReactNode;
}) => {
    const theme = useTheme();
    const styles = useAppSelector((state) => Widget.selectors.selectWidgetTitleStyle(state, uniqid), shallowEqual);

    const styleValues = useMemo(() => {
        return {
            color: styles && styles['color'] ? String(styles['color']) : theme.color.black,
            backgroundColor: styles && styles['background-color'] ? String(styles['background-color']) : 'transparent',
            fontSize: styles && styles['font-size'] ? String(styles['font-size']) : '16',
            fontWeight: styles && styles['font-weight'] ? String(styles['font-weight']) : 'medium',
            textAlign: styles && styles['text-align'] ? String(styles['text-align']) : 'left',
        };
    }, [styles, theme]);

    return (
        <UIHeaderWrapper backroundColor={styleValues.backgroundColor}>
            <UIHeader>
                <UIHeaderFlex>
                    <WidgetIntranetTitle
                        uniqid={uniqid}
                        fontWeight={styleValues.fontWeight}
                        fontSize={styleValues.fontSize}
                        textAlign={styleValues.textAlign}
                        color={styleValues.color}
                    />
                    {subHeader && subHeader(styleValues.color)}
                </UIHeaderFlex>
                {dropdown && dropdown()}
            </UIHeader>
        </UIHeaderWrapper>
    );
};
